// components/IntegrationSupport.tsx
import Image from 'next/image'
import Link from 'next/link'

export default function IntegrationSupport() {
    return (
        <section className='relative flex min-h-[534px] w-full flex-col items-center justify-center overflow-hidden bg-[#141b2c] md:h-[534px] md:flex-row md:items-center md:justify-center'>
            {/* Background */}
            <div className='absolute inset-0 max-w-[1600px]'>
                {/* Blurred Circle */}
                <div className='absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#24056d] blur-[227px]' />

                {/* Concentric Circles */}
                <div className='absolute left-[923px] -top-[152px] hidden h-[847px] w-[847px] -scale-x-100 rounded-full border border-white/50 md:block' />
                <div className='border-white/35 absolute left-[1036px] -top-[98px] hidden h-[739px] w-[739px] -scale-x-100 rounded-full border md:block' />
                <div className='absolute left-[1163px] -top-[41px] hidden h-[625px] w-[625px] -scale-x-100 rounded-full border border-white/20 md:block' />
            </div>

            {/* Left Content */}
            <div className='relative z-10 flex w-[90%] max-w-[604px] flex-col items-start gap-4 px-6 py-10 md:absolute md:left-28 md:top-1/2 md:-translate-y-1/2 md:px-0 md:py-0'>
                <h2 className=' bg-gradient-to-r from-cyan-400 md:h-16 to-blue-400 bg-clip-text text-left text-3xl  font-bold leading-10 text-transparent md:text-5xl'>
                    Integration Support
                </h2>
                <p className='text-base font-medium leading-[170%] text-white md:text-lg'>
                    Platform can be accessed by any modern browser, progressive web application for mobile,
                    optional desktop applications.
                </p>
                <Link
                    href='/contact?ref=integra-ai-integration&utm_source=website&utm_medium=cta&utm_campaign=integra_ai&utm_content=integra_ai__integration__request_demo'
                    className='rounded-full border border-blue-700 bg-blue-700 px-5 py-2 text-sm text-white transition hover:bg-blue-500 sm:px-6 sm:text-base'>
                    Request Demo
                </Link>
            </div>

            {/* Right Side Logos + Text */}
            <div className='relative z-10 mt-10 flex w-full flex-col items-center justify-center gap-4 px-6 md:absolute md:left-[906px] md:top-24 md:mt-0 md:h-[342px] md:w-[548px] md:flex-none'>
                {/* Logos */}
                <div className='flex flex-wrap items-center justify-center gap-6 md:block'>
                    <Image
                        src='/Integra-ai/k2.png'
                        alt='GPT Logo'
                        width={42}
                        height={42}
                        className='md:absolute md:left-[calc(50%_-_274px)] md:top-[150px]'
                    />
                    <div className='h-[42px] w-[42px] overflow-hidden md:flex hidden md:absolute md:left-[109px] md:top-[200px]'>
                        <Image src='/Integra-ai/k7.png' alt='g-3140' width={42} height={42} />
                    </div>
                    <Image
                        src='/Integra-ai/k3.png'
                        alt='Perplexity'
                        width={42}
                        height={42}
                        className='rounded md:absolute md:left-2.5 md:top-[250px]'
                    />
                    <Image
                        src='/Integra-ai/k4.png'
                        alt='Frame0'
                        width={42}
                        height={42}
                        className=' md:left-[142px] md:top-0'
                    />
                    <Image
                        src='/Integra-ai/k5.png'
                        alt='Frame1'
                        width={42}
                        height={42}
                        className='md:absolute md:left-[110px] md:top-[100px]'
                    />
                    <Image
                        src='/Integra-ai/k1.png'
                        alt='Layer10'
                        width={42}
                        height={42}
                        className='md:absolute md:left-[11px] md:top-[50px]'
                    />
                    <div className='h-[42px] w-[42px] overflow-hidden md:absolute md:left-[142px] md:top-[300px]'>
                        <Image src='/Integra-ai/k6.png' alt='Group' width={42} height={42} />
                    </div>
                </div>

                {/* Text */}
                <h3 className='text-2xl l lg:hidden 2xl:flex font-bold leading-[135%] text-[#eeeeee] md:absolute md:left-[calc(50%_-_-24px)] md:top-[143px] md:text-4xl'>
                    AI Providers
                </h3>
                <p className='text-sm font-medium lg:hidden 2xl:flex italic leading-[170%] text-white md:absolute md:left-[298px] md:top-[204px]'>
                    And many more...
                </p>
            </div>
        </section>
    )
}
